export function buildPartialSuccessMessage(results: any[], limit = 2) {
  const created = results.filter((r) => r.created).map((r) => r.receipt_id);

  const failed = results.filter((r) => !r.created).map((r) => r.receipt_id);

  const formatList = (list: string[]) => {
    if (list.length <= limit) {
      return list.map((id) => `'${id}'`).join(" and ");
    }
    return `${list
      .slice(0, limit)
      .map((id) => `'${id}'`)
      .join(" and ")} and others`;
  };

  return `Some records were created (${formatList(
    created
  )}), some failed (${formatList(failed)})`;
}
